// React/Redux
import React, { Component } from "react";
import { connect } from "react-redux";

// Material UI
import ButtonBase from "@material-ui/core/ButtonBase";

// PAC
import { salesStatuses } from "./salesStatuses";

class FirstMeetingArrow extends Component {
  state = {
    activities: []
  };

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      const { activities } = this.props;

      this.setState({
        activities
      });
    }
  }

  onClick = e => {
    e.preventDefault();
    this.props.onClick("First Meeting", salesStatuses.FIRST_MEETING);
  };

  render() {
    return (
      <div className="arrow-container">
        <div className="arrow-btn arrow-first-meeting">
          <ButtonBase onClick={this.onClick}>
            <span className="arrow-btn-label">
              {this.state.activities.length} <br />
              First Meeting
            </span>
          </ButtonBase>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    activities: state.salesActivity.firstMeeting
  }
}

export default connect(mapStateToProps)(FirstMeetingArrow);
